export const queryParamService = {
  get: (name) => {
    const urlParams = new URLSearchParams(
      window.location.search
    );

    const queryParam = urlParams.get(name);

    return queryParam;
  }
};
